/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfieldstudent2Inputs */

const en_ticketsfieldstudent2 = /** @type {(inputs: Ticketsfieldstudent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Students`)
};

const de_ticketsfieldstudent2 = /** @type {(inputs: Ticketsfieldstudent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studierende`)
};

/**
* | output |
* | --- |
* | "Students" |
*
* @param {Ticketsfieldstudent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfieldstudent2 = /** @type {((inputs?: Ticketsfieldstudent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfieldstudent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfieldstudent2(inputs)
	return de_ticketsfieldstudent2(inputs)
});
export { ticketsfieldstudent2 as "ticketsFieldStudent" }